import { memo, useState } from 'react'
import { useSelector } from 'react-redux'

import { selectCustomFieldValueForCustomFieldKeyAndCategoryType } from 'ducks/crm/contacts'
import { selectCustomFieldForId } from 'ducks/crm/customFields'

import CustomFieldWithMenuPositioning from './CustomFieldWithMenuPosition'

export default memo(CustomField)

function CustomField({ categoryType, customFieldId, subjectId }) {
  const {
    icon: customFieldIcon = 'updatedAssign',
    key: customFieldKey,
    name: customFieldName,
    type: customFieldType,
  } = useSelector(state => selectCustomFieldForId(state, { id: customFieldId }))
  const { value: customFieldValue } =
    useSelector(state =>
      selectCustomFieldValueForCustomFieldKeyAndCategoryType(state, {
        customFieldKey,
        categoryType,
      })
    ) || {}
  const [openMenu, setOpenMenu] = useState(null)
  return (
    <CustomFieldWithMenuPositioning
      customFieldIcon={customFieldIcon}
      customFieldKey={customFieldKey}
      customFieldName={customFieldName}
      customFieldType={customFieldType}
      customFieldValue={customFieldValue}
      openMenu={openMenu}
      onOpen={setOpenMenu}
      shouldDoPositioning={!!openMenu}
      subjectId={subjectId}
    />
  )
}
